import React, { useState, useEffect } from 'react'
import AdminTitle from '../AdminTitle'
import { useParams, Link } from 'react-router-dom';
import axios from 'axios'

// areaについては戻せるように一旦コメントアウト化、様子を見て使用しなさそうなら削除
type Job = {
  pr_flag: boolean,
  company_name: string,
  phone_number: string,
  closing_date: string,
  company_image: {url: string} | null,
  catch_copy: string,
  positions: string[],
  industry: string,
  salary: string,
  // area: string,
  japanese_level: string,
  tags: string[],
  appeal_point: string,
  employment_type: string,
  visa_type: string,
  working_hours: string,
  probation_period: string,
  postal_code: string,
  prefecture: string,
  city: string,
  address: string,
  building_name: string,
  transportation_fee: string,
  holidays: string,
  overtime: string,
  salary_increase_criteria: string,
  insurance: string,
  benefits: string,
  residence_permit: string,
  interview_method: string,
  work_environment_age: string,
  work_environment_gender: string,
  work_environment_foreign_ratio: string,
  work_environment_language: string,
  work_environment_hiring_exp: string,
  work_environment_japanese_freq: string,
}

export default function JobShow() {
  const [job, setJob] = useState<Job>({
    pr_flag: false,
    company_name: '',
    phone_number: '',
    closing_date: '',
    company_image: null,
    catch_copy: '',
    positions: [],
    industry: '',
    salary: '',
    // area: '',
    japanese_level: '',
    tags: [],
    appeal_point: '',
    employment_type: '',
    visa_type: '',
    working_hours: '',
    probation_period: '',
    postal_code: '',
    prefecture: '',
    city: '',
    address: '',
    building_name: '',
    transportation_fee: '',
    holidays: '',
    overtime: '',
    salary_increase_criteria: '',
    insurance: '',
    benefits: '',
    residence_permit: '',
    interview_method: '',
    work_environment_age: '',
    work_environment_gender: '',
    work_environment_foreign_ratio: '',
    work_environment_language: '',
    work_environment_hiring_exp: '',
    work_environment_japanese_freq: '',
  })

  // 現在のページのidを取得
  const query = useParams().id

  // APIからデータを取得
  useEffect(() => {
    axios.get(`/api/v1/jobs/${query}`)
    .then (res => {
      setJob({
        pr_flag: res.data.job.pr_flag,
        company_name: res.data.job.company_name,
        phone_number: res.data.job.phone_number,
        closing_date: res.data.job.closing_date,
        company_image: res.data.job.company_image,
        catch_copy: res.data.job.catch_copy,
        positions: res.data.job.positions,
        industry: res.data.job.industry,
        salary: res.data.job.salary,
        // area: res.data.job.area,
        japanese_level: res.data.job.japanese_level,
        tags: res.data.job.tags,
        appeal_point: res.data.job.appeal_point,
        employment_type: res.data.job.employment_type,
        visa_type: res.data.job.visa_type,
        working_hours: res.data.job.working_hours,
        probation_period: res.data.job.probation_period,
        postal_code: res.data.job.postal_code,
        prefecture: res.data.job.prefecture,
        city: res.data.job.city,
        address: res.data.job.address,
        building_name: res.data.job.building_name,
        transportation_fee: res.data.job.transportation_fee,
        holidays: res.data.job.holidays,
        overtime: res.data.job.overtime,
        salary_increase_criteria: res.data.job.salary_increase_criteria,
        insurance: res.data.job.insurance,
        benefits: res.data.job.benefits,
        residence_permit: res.data.job.residence_permit,
        interview_method: res.data.job.interview_method,
        work_environment_age: res.data.job.work_environment_age,
        work_environment_gender: res.data.job.work_environment_gender,
        work_environment_foreign_ratio: res.data.job.work_environment_foreign_ratio,
        work_environment_language: res.data.job.work_environment_language,
        work_environment_hiring_exp: res.data.job.work_environment_hiring_exp,
        work_environment_japanese_freq: res.data.job.work_environment_japanese_freq,
      })
    })
    .catch (err => {
      console.log(err);
      alert("データの取得に失敗しました。");
    });
  }, [query]);

  return (
    <>
      <AdminTitle title={'求人詳細'} />
      <div className='breadcrumb'>
        <ul>
        <li><a href='/admins/jobs'>求人一覧</a></li>
          <li>{job.company_name}</li>
        </ul>
      </div>
      <div className='admin-bg__color'>
        <div className='admin-card'>
          <div className='admin-card__container'>
            <div className="d-flex justify-content-end">
              <Link to={`/admins/jobs/edit/${query}`} className='btn admin-show__btn-edit'>
                <span className='material-symbols-outlined'>edit</span>
                編集
              </Link>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>PR求人</div>
              </div>
              <div className={job.pr_flag ? 'admin-show__group--value pr' : 'admin-show__group--value'}>
                {job.pr_flag ? ('PR求人あり') : ('PR求人なし')}
              </div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>企業名</div>
              </div>
              <div className='admin-show__group--value'>{job.company_name}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>電話番号</div>
              </div>
              <div className='admin-show__group--value'>{job.phone_number}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>掲載最終日</div>
              </div>
              <div className='admin-show__group--value'>{job.closing_date}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>掲載企業用写真</div>
              </div>
              <div className='admin-show__group--value'>
                { job.company_image && <img src={job.company_image.url} width='173' height='115' /> }
              </div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>キャッチコピー</div>
              </div>
              <div className='admin-show__group--value'>{job.catch_copy}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>募集職種</div>
              </div>
              <div className='admin-show__group--value'>
                {job.positions.map(position =>
                  <div>{`・${position}`}</div>
                )}
              </div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>業種</div>
              </div>
              <div className='admin-show__group--value'>{job.industry}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>給与</div>
              </div>
              <div className='admin-show__group--value'>{job.salary}</div>
            </div>

            {/* <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>地域</div>
              </div>
              <div className='admin-show__group--value'>{job.area}</div>
            </div> */}

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>日本語レベル</div>
              </div>
              <div className='admin-show__group--value'>{job.japanese_level}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>タグ</div>
              </div>
              <div className='admin-show__group--tags'>
                {job.tags.map(tag =>
                  <li>{`＃${tag}`}</li>
                )}
              </div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>アピールポイント</div>
              </div>
              <div className='admin-show__group--value'>{job.appeal_point}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>雇用形態</div>
              </div>
              <div className='admin-show__group--value'>{job.employment_type}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>要求ビザ種目</div>
              </div>
              <div className='admin-show__group--value'>{job.visa_type}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>勤務時間</div>
              </div>
              <div className='admin-show__group--value'>{job.working_hours}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>試用期間</div>
              </div>
              <div className='admin-show__group--value'>{job.probation_period}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>住所</div>
              </div>
              <div className='admin-show__group--value'>{`〒${job.postal_code}\n`} {job.prefecture} {job.city} {job.address} {job.building_name}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>交通費</div>
              </div>
              <div className='admin-show__group--value'>{job.transportation_fee}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>休日</div>
              </div>
              <div className='admin-show__group--value'>{job.holidays}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>時間外労働</div>
              </div>
              <div className='admin-show__group--value'>{job.overtime}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>給与昇給基準</div>
              </div>
              <div className='admin-show__group--value'>{job.salary_increase_criteria}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>加入保険</div>
              </div>
              <div className='admin-show__group--value'>{job.insurance}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>その他特典</div>
              </div>
              <div className='admin-show__group--value'>{job.benefits}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>在留資格</div>
              </div>
              <div className='admin-show__group--value'>{job.residence_permit}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>面接方法</div>
              </div>
              <div className='admin-show__group--value'>{job.interview_method}</div>
            </div>

            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>職場環境/雰囲気</div>
              </div>
              <div className="admin-show__group--label-letter ms-2 mt-4">多い年齢層</div>
              <div className='admin-show__group--progress-bar'>
                <input type='radio' className={job.work_environment_age === 'teen' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_age === 'twenties' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_age === 'thirties' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_age === 'forties' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_age === 'fifties' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_age === 'sixties' ? 'selected' : ''} disabled />
              </div>
              <div className='admin-show__group--progress-label'>
                <div>10代</div>
                <div>20代</div>
                <div>30代</div>
                <div>40代</div>
                <div>50代</div>
                <div>60代</div>
              </div>

              <div className="admin-show__group--label-letter ms-2 mt-4">男女の割合</div>
              <div className='admin-show__group--progress-bar'>
                <input type='radio' className={job.work_environment_gender === 'man' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_gender === 'slightly_man' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_gender === 'same' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_gender === 'slightly_woman' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_gender === 'woman' ? 'selected' : ''} disabled />
              </div>
              <div className='admin-show__group--progress-label'>
                <div>男性</div>
                <div>女性</div>
              </div>

              <div className="admin-show__group--label-letter ms-2 mt-4">外国人が働いている割合</div>
              <div className='admin-show__group--progress-bar'>
                <input type='radio' className={job.work_environment_foreign_ratio === 'many' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_foreign_ratio === 'slightly_many' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_foreign_ratio === 'same' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_foreign_ratio === 'slightly_few' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_foreign_ratio === 'few' ? 'selected' : ''} disabled />
              </div>
              <div className='admin-show__group--progress-label-m'>
                <div className="ms-2">多い</div>
                <div>少ない</div>
              </div>

              <div className="admin-show__group--label-letter ms-2 mt-4">英語または母国語を活かせる環境</div>
              <div className='admin-show__group--progress-bar'>
                <input type='radio' className={job.work_environment_language === 'many' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_language === 'slightly_many' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_language === 'same' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_language === 'slightly_few' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_language === 'few' ? 'selected' : ''} disabled />
              </div>
              <div className='admin-show__group--progress-label-m'>
                <div className="ms-2">多い</div>
                <div>少ない</div>
              </div>

              <div className="admin-show__group--label-letter ms-2 mt-4">外国人の採用経験</div>
              <div className='admin-show__group--progress-bar'>
                <input type='radio' className={job.work_environment_hiring_exp === 'no_have' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_hiring_exp === 'have' ? 'selected' : ''} disabled />
              </div>
              <div className='admin-show__group--progress-label'>
                <div>なし</div>
                <div>あり</div>
              </div>

              <div className="admin-show__group--label-letter ms-2 mt-4">日本語を使う頻度</div>
              <div className='admin-show__group--progress-bar'>
                <input type='radio' className={job.work_environment_japanese_freq === 'many' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_japanese_freq === 'slightly_many' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_japanese_freq === 'same' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_japanese_freq === 'slightly_few' ? 'selected' : ''} disabled />
                <input type='radio' className={job.work_environment_japanese_freq === 'few' ? 'selected' : ''} disabled />
              </div>
              <div className='admin-show__group--progress-label-m'>
                <div className="ms-2">多い</div>
                <div>少ない</div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
